/**
 * This Helper checks to see if the current transaction is "cppLancer",
 *    and if so, finds and hides the roster Copy button.  Per requirements,
 *    we were asked to show this button on the Prior Carrier page for
 *    CommlAuto and Limo, but not CPP.
 */

// Setup the namespace for this logic
var cppHideRosterCopyButtonHelper = cppHideRosterCopyButtonHelper || {};
var hideFirstRosterDeleteButtonHelper = hideFirstRosterDeleteButtonHelper || {};


cppHideRosterCopyButtonHelper.initialize = function() {
	ap.consoleInfo("cppHideRosterCopyButtonHelper initialize!");
	
	var transactionNameField = $("input#TRANSACTION_NAME")[0];
	if (transactionNameField && transactionNameField.value=="cppLancer") {
		var copyLink = $("a.copyAction")[0];
		if (copyLink) {
			copyLink.style.display = "none";
		}
	}
};

hideFirstRosterDeleteButtonHelper.initialize = function() {
	ap.consoleInfo("hideFirstRosterDeleteButtonHelper initialize!");
	
	var deleteLink = $("a.deleteAction")[0];
	if (deleteLink) {
		deleteLink.style.display = "none";
	}
};


